export { default } from './ProductAccordions';
